import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import "./Navbar.css";

export default function SiteNavbar() {
  const [isOpen, setIsOpen] = useState(false);
  const { user, loading, logout } = useAuth();
  const navigate = useNavigate();

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  const isAuthenticated = !!(user && user.email);

  const handleDashboardClick = () => {
    closeMenu();
    navigate(user.role === "admin" ? "/admin" : "/dashboard");
  };

  return (
    <nav className="navbar">
      {/* Logo */}
      <Link to="/" className="navbar-logo" onClick={closeMenu}>
        <img
          src="https://res.cloudinary.com/dfs2sqkxy/image/upload/v1766292981/logo_vdd5yn.png"
          alt="logo"
        />
      </Link>

      {/* Hamburger */}
      <div className="hamburger" onClick={toggleMenu}>
        <span></span>
        <span></span>
        <span></span>
      </div>

      {/* Menu */}
      <ul className={`nav-links ${isOpen ? "open" : ""}`}>
        <li><Link to="/" onClick={closeMenu}>Home</Link></li>
        <li><Link to="/about" onClick={closeMenu}>About Me</Link></li>
        <li><Link to="/technews" onClick={closeMenu}>Tech News</Link></li>
        <li><Link to="/publications" onClick={closeMenu}>Publications</Link></li>
        <li><Link to="/videos" onClick={closeMenu}>Videos</Link></li>
        <li><Link to="/services" onClick={closeMenu}>Services</Link></li>
        <li><Link to="/projects" onClick={closeMenu}>Projects</Link></li>

        {!loading && (
          isAuthenticated ? (
            <>
              <li>
                <span className="nav-link" onClick={handleDashboardClick}>
                  Dashboard
                </span>
              </li>
              <li>
                <span className="nav-link" onClick={() => { logout(); closeMenu(); }}>
                  Logout
                </span>
              </li>
            </>
          ) : (
            <li>
              <Link to="/login" onClick={closeMenu} className="nav-link">
                Sign In / Sign Up
              </Link>
            </li>
          )
        )}
      </ul>
    </nav>
  );
}
